module.exports = __webpack_public_path__ + "static/media/why_id.b2ecbda7.vtt";